'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { MediaPickerModalContent } from '../core/media-picker-modal-content';
import { ModalLayout } from '../core/modal-layout';

export function MediaPickerModal(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Media Picker" isOpen={modal?.open === ModalDrawer.MEDIA_PICKER}>
      <MediaPickerModalContent />
    </ModalLayout>
  );
}
